import { render } from "./SurveyBuilderDownloader.vue?vue&type=template&id=33ec8f08&scoped=true"
import script from "./SurveyBuilderDownloader.vue?vue&type=script&lang=js"
export * from "./SurveyBuilderDownloader.vue?vue&type=script&lang=js"

import "./SurveyBuilderDownloader.vue?vue&type=style&index=0&id=33ec8f08&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ec8f08"]])

export default __exports__